export default __webpack_public_path__ + "static/media/INSURE-TECH-IMG.f183dd1e.gif";